import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navigation.css";
import yadi_logo from "../assets/yadi_logo.png";

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about-us" },
    { label: "Areas Of Practice", path: "/areas-of-practice" },
    { label: "Advocates", path: "/lawyers" },
    { label: "Internship", path: "/internship" },
    { label: "Careers", path: "/careers" },
    { label: "Blog", path: "/blog" },
    { label: "Contact Us", path: "/contact-us" },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-header">
          <div className="contact-info-1">
            <div className="contact-item-1">
              <span className="icon">📍</span>
              <span className="contact-text">Hyderabad, Telangana</span>
            </div>

            <div className="contact-item-1">
              <span className="icon">✉️</span>
              <a
                href="mailto:yadishwarn.advocate@gmail.com"
                className="contact-text contact-link"
              >
                yadishwarn.advocate@gmail.com
              </a>
            </div>

            <div className="contact-item-1">
              <span className="icon">📞</span>
              <a href="tel:+919398604124" className="contact-text contact-link">
                (+91) 9398604124
              </a>
            </div>
          </div>
        </div>

        <div className="nav-menu-container">
          <Link to="/" className="nav-logo" onClick={closeMobileMenu}>
            <img
              src={yadi_logo}
              alt="Yadi Legal Chamber Logo"
              className="logo-image"
            />
            <div className="logo-text-wrap">
              <h2>YADI LEGAL CHAMBER</h2>
              <span className="logo-subtitle">Professional Legal Services</span>
            </div>
          </Link>

          <button
            className={`mobile-menu-toggle ${isMobileMenuOpen ? "active" : ""}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul className={`nav-menu ${isMobileMenuOpen ? "mobile-open" : ""}`}>
            {navItems.map((item, index) => (
              <li className="nav-item" key={index}>
                <Link
                  to={item.path}
                  className="nav-link"
                  onClick={closeMobileMenu}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;